export const createGetPostGenerationTemplatesRequest = () => {
  return {
    method: "GET",
    url: "/post_generation_templates",
  };
};

export const createGetPostGenerataionTemplatesRequestV2 = () => {
  return {
    method: "GET",
    url: "/post_generation_templates/v2",
  }
}


export const createGetPostGenerationTemplateRequest = (id) => {
  return {
    method: "GET",
    url: `/post_generation_templates/${id}`,
  };
};

export const createCreatePostGenerationTemplateRequest = (content) => {
  return {
    method: "POST",
    url: "/custom_post_formats",
    data: {
      content,
    },
  };
};

export const createDeletePostGenerationTemplateRequest = (id) => {
  return {
    method: "DELETE",
    url: `/custom_post_formats/${id}`,
  };
};

export const createUpdatePostGenerationTemplateRequest = (id, content) => {
  return {
    method: "PUT",
    url: `/custom_post_formats/${id}`,
    data: {
      content,
    },
  };
};

export const createGetRepurposePostGenerationTemplateRequest = (id, content) => {
  return {
    method: "GET",
    url: `/post_generation_templates/repurpose_template`,
    data: {
      id,
      content,
    },
  };
};
